module.exports = __webpack_public_path__ + "img/example-doc.15705552.svg";